<template>
    <ul :class="['navbar-nav', 'justify-content-center d-flex flex-column mr-0']">
        <cph-sidebar-navigation-link
            :to="{name: $TYPES.ROUTES.PRODUCTS}"
            iconName="icon-cph_iconset_PRODUKTAUSWAHL"
            :text="$t('COMMON.products')"/>

        <cph-sidebar-navigation-link
            :to="{name: $TYPES.ROUTES.ANALYTICS}"
            iconName="icon-cph_iconset_statistic03"
            :text="$t('SIDEBAR.analytics')"/>

        <!--<cph-sidebar-navigation-link
            :to="$TYPES.ROUTES.ORDERS"
            iconName="icon-cph_iconset_Auftragssuche"
            :text="$t('SIDEBAR.orders')"/>

        <cph-sidebar-navigation-link
            :to="{name: $TYPES.ROUTES.REGISTRATION }"
            iconName="icon-cph_iconset_sign_area"
            :text="$t('SIDEBAR.registration')"/>-->

        <cph-sidebar-navigation-link
            :to="{name: $TYPES.ROUTES.SHOPS }"
            iconName="icon-cph_iconset_heimversandundshopabholung"
            :text="$t('SIDEBAR.shops')"/>

        <cph-sidebar-navigation-link
            :to="{name: $TYPES.ROUTES.USERS+'default' }"
            iconName="icon-cph_iconset_user"
            :text="$t('SIDEBAR.users')"/>

        <cph-sidebar-navigation-link
            :to="{name: $TYPES.ROUTES.PRINTERS }"
            iconName="icon-cph_iconset_printer"
            :text="$t('PRINTERS.printers')"/>

        <cph-sidebar-navigation-link
            :to="{name: $TYPES.ROUTES.TEMPLATES }"
            iconName="icon-cph_iconset_add_image"
            :text="$t('COMMON.templates')"/>

        <cph-sidebar-navigation-link
            :to="{name: $TYPES.ROUTES.PROMOTIONS }"
            iconName="icon-cph_iconset_money"
            :text="$t('SIDEBAR.promotions')"/>

    </ul>
</template>
<script type="text/babel">
import CphSidebarNavigationLink from './CphSidebarNavigationLink';
import {SidebarPerimeter} from '../../../router/perimeters/sidebarPerimeter';
export default {
    name: 'cph-sidebar-navigation',
    components: {CphSidebarNavigationLink},
    perimeters: [
        SidebarPerimeter
    ]
};
</script>
<style lang="scss" scoped>
    ul.navbar-nav {
        margin: 0;
        min-height: 1vh;
        width: 100%;
    }


</style>
